import { render } from "./MMStaticPage.vue?vue&type=template&id=e8b90c24"
import script from "./MMStaticPage.vue?vue&type=script&lang=js"
export * from "./MMStaticPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__